const menuOnClick = (link: string) => {
  let menuHeight =
    document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

  var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

  window &&
    window.scrollTo({
      top: location - menuHeight,
      behavior: "smooth",
    });
};

export default menuOnClick;
